module.exports = __webpack_public_path__ + "static/media/icon_cognitive.8b590533.svg";